import { Component,
         OnInit,
         Output,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { TrainService }             from './../shared/train.service';
import { Globals }                  from './../common/globals';
import { TrainDialogComponent }     from './../train-dialog/train-dialog.component';
import { MatDialog }                from '@angular/material';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { TrainDialogModel }         from './../train-dialog/train-dialog.model';
import { TrainSortableFilter }      from './train-sortable-filter';
import { MatSnackBar }              from '@angular/material';
import { duration } from 'moment';

@Component({
  selector: 'sa-train-list',
  template: require('./train-list.component.html'),
  styles: [require('./train-list.component.scss')]
})
export class TrainListComponent implements OnInit {

  @Output() columns: Array<TableColumn>;
  @Output() filter: TrainSortableFilter = new TrainSortableFilter('trainName');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  private apiService: TrainService;

  constructor(
    apiService: TrainService,
    private dialog: MatDialog,
    public globals: Globals,
    private snackbar: MatSnackBar
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);

    this.columns = [
      new TableColumn(TableColumnType.Text, 'trainName', 'Spoj číslo', 50),
      new TableColumn(TableColumnType.Text, 'descr', 'Spoj popis', 150),
      new TableColumn(TableColumnType.Text, 'companyName', 'Společnost', 100),
      new TableColumn(TableColumnType.Text, 'targetStoreName', 'Centrální zásobovací sklad', 150),
      new TableColumn(TableColumnType.Text, 'cycleName', 'Cyklus', 100),
      new TableColumn(TableColumnType.Bool, 'IsEnabled', 'Aktivní', 80)
    ];
  }

  // private filterChanged(e: any) {
  //   console.log('filterChanged');
  //   this.filter = e;
  //   this.performSearch.emit(e);
  // }

  private getData(filter: TrainSortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew(model: TrainDialogModel = null, error: string = null) {

    let snack = this.snackbar;
    let dialogRef = this.dialog.open(TrainDialogComponent);
    if (model === null) {
      model = new TrainDialogModel();
      model.isEnabled = true;
      model.tnTrainCurrencies = [];
      model.tnTrainParts = [];
    }
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = true;

    if (!!error && error.length > 0) {
      dialogRef.componentInstance.errors.push(error);
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(
            res => {
              cloakRef.close();
              snack.open('Úspěšně uloženo.', '', {duration: 2000});
              this.search();
            },
            err => {
              cloakRef.close();
              snack.open(err.message, '', {duration: 2000});
              this.addNew(dialogRef.componentInstance.model, err.message);
            });
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model: TrainDialogModel, error: string = null) {
    let dialogRef = this.dialog.open(TrainDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;
    if (!!error && error.length > 0) {
      dialogRef.componentInstance.errors.push(error);
    }

    let snack = this.snackbar;
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.trainUid, dialogRef.componentInstance.model)
          .subscribe(
              res => {
              cloakRef.close();
              snack.open('Úspěšně uloženo.', '', {duration: 2000});
              this.search();
            },
              err => {
                cloakRef.close();
                window.alert(err.message);
            });
      } else if (result === 'delete') {
        this.apiService.deleteItem(dialogRef.componentInstance.model.trainUid)
          .subscribe(
            data => {
              snack.open('Spoj byl smazán.', '', {duration: 2000});
              this.search();
          },
            err => {
              snack.open('Vybraný spoj nebylo možné odstranit.', 'Zavřít');
            }
          );
      } else {
        this.search();
      }
    });
  }

  ngOnInit() {
  }

  getRowClass(item: any) {
    return 'superclass';
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-list/train-list.component.ts